import { Component, inject, OnDestroy } from '@angular/core';
import { UserIdleService } from '@core/user-idle';
import { filter, Subject, switchMap, take, takeUntil } from 'rxjs';
import { ContentDialogData, ErrorDialogComponent } from '@portal/dialog';
import { ROUTE } from '@portal/data-access';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'portal-root',
  template: '<router-outlet></router-outlet>',
  styles: [':host {@apply block;}'],
})
export class AppComponent implements OnDestroy {
  private readonly idleService = inject(UserIdleService);
  private readonly destroy$ = new Subject<void>();
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);

  constructor() {
    this.idleService.startWatching();

    this.idleService
      .onTimerStart()
      .pipe(
        // Filter all the timer start events
        filter(Boolean),
        take(1),
        switchMap(() =>
          this.dialog
            .open<ErrorDialogComponent, ContentDialogData>(ErrorDialogComponent, {
              panelClass: ['w-10/12', '!max-w-md'],
              data: { title: '', dialogContent: 'sessionExpired', button: { close: { hide: true } } },
            })
            .afterClosed()
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(() =>
        this.router
          .navigate([ROUTE.VERIFICATION.MAIN])
          .then(() => this.dialog.closeAll())
          .catch(() => this.dialog.closeAll())
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.idleService.stopWatching();
  }
}
